// Scales a set of weights so they sum to exactly 100, preserving their
// relative ratios (or splitting evenly if every input is 0). Rounding can
// leave the sum a point or two off 100 — the remainder ("drift") is nudged
// onto the largest values first so no single item takes an outsized swing.
export const distributeToHundred = (weights: number[]): number[] => {
	if (weights.length === 0) return [];
	const total = weights.reduce((s, w) => s + (w || 0), 0);
	const rounded = weights.map(w =>
		Math.round(total > 0 ? ((w || 0) / total) * 100 : 100 / weights.length),
	);
	let drift = 100 - rounded.reduce((s, v) => s + v, 0);
	const order = rounded.map((v, i) => ({ v, i })).sort((a, b) => b.v - a.v);
	let k = 0;
	while (drift !== 0 && order.length > 0) {
		const idx = order[k % order.length].i;
		rounded[idx] += drift > 0 ? 1 : -1;
		drift += drift > 0 ? -1 : 1;
		k++;
	}
	return rounded;
};
